
import auth from '../auth'
import { mapState, mapMutations } from 'vuex'
import Loading from 'vux/src/components/loading/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'


import echarts from 'echarts';
import '../../node_modules/echarts/theme/vintage.js';

const list = () => ['< 返回', '成交价格', '成交量', '户型分布']

export default {
  components: {
    Loading,
    Tab,
    TabItem,
    Sticky,
    Divider,
    XButton,
    Swiper,
    SwiperItem
  },
  data () {
    return {
      show1: true,
      text1: '加载中',

      list2: list(),
      demo2: '成交价格',
      index: 1,
      openid: '',
      token: '',
      community: '',
      respData: {},
      reqApiDataUrl: null,
      reqType: null,
      chart: {}
    }
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    detailData: state => state.jw.detailData
  }),
  mounted() {
    console.log(">>>Detail Price state state:%o",this.$store.state)
    console.log("created...")
    console.log('get openid:%s', auth.getOpenid())
    console.log('get token:%s', auth.getToken())
    console.log("route.query.cm:%s",this.$route.query.cm)
    let cm = auth.getCm()
    let newcm = this.$route.query.cm
    console.log("newcm:%s, cm:%s", newcm, cm)
    if(typeof(this.$route.query.cm)!= "undefined" && cm != newcm){
      console.log("update new cm")
      auth.setCm(newcm)
      cm = newcm
    }

    this.community = cm
    console.log("reqApiData")
    this.openid = auth.getOpenid()
    this.token = auth.getToken()
    this.reqApiData(this.openid, this.token, this.community)

    if(typeof(this.$route.query.type)!= "undefined"){
      this.reqType = this.$route.query.type
      console.log("reqType:%s", this.reqType)
      auth.setCmType(this.reqType)
    }
  },
  methods: {
    ...mapMutations([
      'updateData',
      'clearData'
    ]),
    barHandler: function(item){
      switch(item)
      {
        case this.list2[0]:
          console.log("return home");
          this.$router.push({ path: '/',query: { type: this.$store.state.jw.type }});
          break;
        case this.list2[1]:
          break;
        case this.list2[2]:
          break;
        default:
          break;
      }
    },
    drawbar(id, priceData, bjPriceData) {
      this.chart = echarts.init(document.getElementById(id));

      this.chart.setOption({
        baseOption:{
          title: {
              text: '成交量',
              subtext: '数据来自网络'
          },
          tooltip: {
              trigger: 'axis'
          },
          legend: {
              orient: 'vertical',
              data:[priceData.name, '北京']
          },
          grid: {
              show: true,
              left: '1%',
              right: '1%',
              //bottom: '3%',
              containLabel: true
          },
          toolbox: {
              feature: {
                dataView: {readOnly: false},
                saveAsImage: {}
              }
          },
          xAxis: {
            type: 'value',
            scale: true,
            position:'top'
          },
          yAxis: {
            type: 'category',
            inverse: true,
            boundaryGap: true,
            data: priceData.categories
          },
          series: [
            {
              name: priceData.name,
              type:'bar',
              data: priceData.data,
              markPoint: {
                data: [
                  {type: 'max', name: '最大值'},
                  {type: 'min', name: '最小值'}
                ]
              },
              markLine: {
                data: [
                  {type: 'average', name: '平均值'}
                ]
              }
            },
            {
                name:'北京',
                type:'bar',
                data: bjPriceData.data
            }
          ]
        },
         media: [
            {
              option: {
                grid: {
                  show: true,
                  left: '1%',
                  right: '1%',
                  bottom: '1%',
                  containLabel: true
                }
              }
            },
            {
              query: {
                  maxWidth: 320              // 当容器宽度小于 500 时。
              },
              option: {
                grid: {
                  show: true,
                  left: '1%',
                  right: '1%',
                  bottom: '30%',
                  containLabel: true
                }
              }
            }
        ]


      });
    },
    drawpie(id, centery, bedroom, bjbedroom) {
      console.log("id:%s, centery:%s, bedroom:%o, bjbedroom:%o", id, centery, bedroom, bjbedroom);
      this.chart = echarts.init(document.getElementById(id));
      this.chart.setOption({

      baseOption: {
          title : {
              text: '户型分布',
              subtext: '数据来自网络'
              //x:'left'
          },
          tooltip : {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
              data: bedroom.categories
          },
          toolbox: {
              show : true,
              feature : {
                  mark : {show: true},
                  dataView : {show: true, readOnly: false},
                  magicType : {
                      show: true,
                      type: ['pie', 'funnel']
                  },
                  saveAsImage : {show: true}
              }
          },
          calculable : true,
          series : [
              {
                  name:'半径模式',
                  type:'pie',
                  roseType : 'radius',
                  label: {
                      normal: {
                          show: true
                      },
                      emphasis: {
                          show: true
                      }
                  },
                  lableLine: {
                      normal: {
                          show: true
                      },
                      emphasis: {
                          show: true
                      }
                  },
                  data: bedroom.data
              },
              {
                  name:'面积模式',
                  type:'pie',
                  roseType : 'area',
                  data: bjbedroom.data
              }
          ]
      },
      media: [
        {
            option: {
                legend: {
                    right: 'center',
                    orient: 'horizontal'
                },
                series: [
                    {
                        radius: ['10%', '30%'],
                        center: ['50%', '30%']
                    },
                    {
                        radius: ['10%', '30%'],
                        center: ['50%', '65%']
                    }
                ]
            }
        }

      ]


      });
    },
    drawLine(id, linedata, bjlinedata) {
      console.log("drawline> id:%s, linedata:%o, bjlinedata:%o", id, linedata, bjlinedata);
      this.chart = echarts.init(document.getElementById(id));
      this.chart.setOption({

        baseOption:{
          title: {
            text: '成交价格',
            subtext: '数据来自网络'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            orient: 'vertical',
            data:[linedata.name,'北京']
          },
          grid: {
            show: true,
            left: '1%',
            right: '1%',
            containLabel: true
          },
          toolbox: {
            feature: {
              dataView: {readOnly: false},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'value',
            scale: true,
            position:'top'
          },
          yAxis: {
            type: 'category',
            inverse: true,
            boundaryGap: true,
            data: linedata.categories
          },
          series: [
            {
              name: linedata.name,
              type:'line',
              data: linedata.data,
              markPoint: {
                data: [
                  {type: 'max', name: '最大值'},
                  {type: 'min', name: '最小值'}
                ]
              },
              markLine: {
                data: [
                  {type: 'average', name: '平均值'}
                ]
              }
            },
            {
              name:'北京',
              type:'line',
              data: bjlinedata.data
            }
          ]
        },
        media: [
          {
            option: {
              grid: {
                show: true,
                left: '1%',
                right: '1%',
                bottom: '1%',
                containLabel: true
              }
            }
          },
          {
            query: {
                maxWidth: 320              // 当容器宽度小于 500 时。
            },
            option: {
              grid: {
                show: true,
                left: '1%',
                right: '1%',
                bottom: '30%',
                containLabel: true
              }
            }
          }
        ]

      });
    },
    transform(obj, name, type){
      console.log("obj:%o, name:%s, type:%d", obj, name, type);
      let to = new Object();
      let at = [];
      let as = [];
      let key = '';
      let value = '';
      for(let item in obj){
        if(type === 1){
          key = obj[item]['bedroom'] + "居室"
          value = obj[item]['count']
          value = {value:value, name:key}
        }else{
          key = item
          value = obj[item]
        }
        at.push(key)
        as.push(value)
      }
      to.categories = at;
      to.data = as;
      to.name = name;
      return to;
    },
    load: function(data){
      console.log("data:%o", data)
      if(typeof(data) === "undefined" || typeof(data.price) === "undefined"){
        console.error("input data error : " + data)
        return
      }
      console.log("data:%o", data)

      let brief_name = this.community;
      let count = new Object();
      let bjcount = new Object();
      count = this.transform(data.count, brief_name, 0)// asyncData
      bjcount = this.transform(data.bj_count, '北京', 0)// bjasyncData
      console.log("load...count:%o", count);
      console.log("load...bjcount:%o", bjcount);
      this.drawbar('dealPrice', count, bjcount);

      let price = new Object();
      let bjprice = new Object();
      price = this.transform(data.price, brief_name, 0)// asyncData
      bjprice = this.transform(data.bj_price, '北京', 0)// bjasyncData
      console.log("load...price:%o", price);
      console.log("load...bjprice:%o", bjprice);
      this.drawLine('dealQty', price, bjprice);

      let bedroom = this.respData.bedroom
      let bj_bedroom = this.respData.bj_bedroom
      bedroom = this.transform(this.respData.bedroom, brief_name, 1)// asyncData
      bj_bedroom = this.transform(this.respData.bj_bedroom, '北京', 1)// bjasyncData
      console.log("load...bedroom:%o", bedroom);
      console.log("load...bj_bedroom:%o", bj_bedroom);
      this.drawpie('dealType', '60%', bedroom, bj_bedroom);

    },
    reqApiData: function(openid, token, community){
      console.log("openid:%s, token:%s, community:%s", openid, token,community)
      let reqType = auth.getCmType()
      let reqHouseAreaUrl = null
      let req_data = null
      console.log("reqType:%s, typeof:%s", reqType, typeof(reqType))
      switch(reqType){
        case '1':
          console.log("bussiness deal")
          req_data = {openid:openid, token:token, bizcycle:community}
          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/bizcycle/deal'
          break;
        case '2':
          console.log("district deal")
          req_data = {openid:openid, token:token, district:community}
          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/district/deal'
          break;
        case '3':
          console.log("city deal")
          req_data = {openid:openid, token:token, city:community}
          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/city/deal'
          break;
        case '0':
        default:
          console.log("nearby deal")
          req_data = {openid:openid, token:token, community:community}
          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/community/deal'
          break;
      }
      var url = reqHouseAreaUrl
      console.log("reqHouseArea url:%s", url);
      this.$http.post(url, req_data).then((response) => {
        console.log("PASS! response:%o", response);
        console.log("status:%s", response.status);
        console.log("statusText:%s", response.statusText);
        console.log("Expires: %s", response.headers.get('Expires'));
        console.log("body: %o", response.body);
        this.respData = response.body.data
        if(this.reqType === '0') {
          console.log("bussiness area")
          console.log("coin: %d", response.body.data.coin)
          auth.setCoins(response.body.data.coin)
        }
        this.load(this.respData)
        this.show1 = false;
      }, (response) => {
        console.error("FAIL!!! response:%o", response);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/DetailTest.vue